import { baseUrl } from "../utils/baseUrl";
import jwtInterceoptor from "./autorizacao/jwt-interceptor";

class ServicosItemPedido {
    
    listarUm(id){
        return jwtInterceoptor.get(`${baseUrl}/itemPedido/lista/${id}`)
    }
    
}

export default new ServicosItemPedido();